const routes = {
  login: {
    root: "/login",
  },
  manageStudent: {
    root: "/home/manage-student",
  },
  manageAgent: {
    root: "/home/manage-agent",
  },
  studentDetails: "/home/manage-student/student-details",
  agentDetails: "/home/manage-agent/agent-details",
  modifyOrder: "/home/manage-student/student-details/modify-order/:studentId",
  cancelOrder: "/home/manage-student/student-details/cancel-order/:studentId",
  default: "/",
  pageNotFound: "*",
};

export default routes;
